export default function CoachTeamMemberCourse() {
  return <h1>This is Coach Team Member Course Using ID</h1>;
}
